const EXIT_DURATION = 340;
const INTRO_HOLD = 180;

const initPageTransition = () => {
    const overlay = document.querySelector('[data-page-transition]');

    if (!overlay || overlay.dataset.pageTransitionReady === 'true') {
        return;
    }

    overlay.dataset.pageTransitionReady = 'true';
    overlay.classList.add('is-managed');
    document.documentElement.classList.add('page-transition-lock');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let navigating = false;
    let unlockTimer = null;

    const unlockPage = () => {
        window.clearTimeout(unlockTimer);
        unlockTimer = window.setTimeout(() => {
            document.documentElement.classList.remove('page-transition-lock');
        }, reducedMotion.matches ? 0 : 480);
    };

    const revealPage = () => {
        navigating = false;
        overlay.classList.remove('is-entering');
        overlay.classList.add('is-hidden');
        unlockPage();
    };

    const coverPage = () => {
        window.clearTimeout(unlockTimer);
        document.documentElement.classList.add('page-transition-lock');
        overlay.classList.add('is-entering');
        overlay.classList.remove('is-hidden');
    };

    const shouldTransition = (event, link) => {
        if (
            event.defaultPrevented ||
            event.button !== 0 ||
            event.metaKey ||
            event.ctrlKey ||
            event.shiftKey ||
            event.altKey ||
            link.hasAttribute('download') ||
            link.hasAttribute('data-no-page-transition') ||
            link.hasAttribute('data-bs-toggle') ||
            link.hasAttribute('data-fancybox') ||
            (link.target && link.target !== '_self')
        ) {
            return false;
        }

        const rawHref = link.getAttribute('href');

        if (!rawHref || rawHref.startsWith('#')) {
            return false;
        }

        const destination = new URL(link.href, window.location.href);
        const current = new URL(window.location.href);

        if (
            !['http:', 'https:'].includes(destination.protocol) ||
            destination.origin !== current.origin ||
            destination.href === current.href
        ) {
            return false;
        }

        const isSameDocument =
            destination.pathname === current.pathname &&
            destination.search === current.search &&
            destination.hash !== current.hash;

        return !isSameDocument;
    };

    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');

        if (!link || navigating || !shouldTransition(event, link)) {
            return;
        }

        event.preventDefault();
        navigating = true;
        coverPage();

        const destination = link.href;
        const delay = reducedMotion.matches ? 0 : EXIT_DURATION;

        window.setTimeout(() => {
            window.location.assign(destination);
        }, delay);
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            revealPage();
        }
    });

    window.setTimeout(revealPage, reducedMotion.matches ? 0 : INTRO_HOLD);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageTransition, { once: true });
} else {
    initPageTransition();
}
